/**
 * Ink and type for the inline SVG sketches (hero, open-source demo).
 *
 * Colours are passed into the markup rather than inherited from CSS so that
 * switching theme rebuilds the sketch with the right ink, which also makes it
 * redraw itself.
 */
export const SKETCH_PALETTE = {
  light: {
    ink: "#27241a",
    quiet: "#9c978a",
    accent: "#2f6a5c",
    accentInk: "#3d5f45",
    wash: "#e7efe8",
  },
  dark: {
    ink: "#f2efe7",
    quiet: "#867f74",
    accent: "#82bbaa",
    accentInk: "#a8cdb6",
    wash: "#21302a",
  },
};

export const SKETCH_SANS =
  "'Urbanist Variable', Urbanist, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif";

export const SKETCH_MONO =
  "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, Menlo, Consolas, monospace";

export default SKETCH_PALETTE;
